/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect, useRef } from 'react';

const API_URL = import.meta.env.VITE_API_URL;

function AllDepartment() {
  const { data, setData } = useDataContext();
  
  // ใช้ useRef ป้องกันการยิงซ้ำ
  const hasFetched = useRef(false);

  useEffect(() => {
    // 1. เช็คว่ามีข้อมูลใน Context หรือยัง (ถ้ามีแล้ว ไม่ต้องโหลดใหม่)
    if (data.docOther && data.docOther.length > 0) {
        return;
    }

    // 2. กันยิงซ้ำใน Strict Mode
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", "Basic SHJAYm9vbnNpcmkuY28udGg6SHJAYnNyISEh");
        
        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow"
        };

        const response = await fetch(`${API_URL}/documents`, requestOptions);
        const result = await response.json();
        
        setData(prevData => ({...prevData, docOther: result.data || []}));
        
      } catch (error) {
        console.error("Error fetching documents (AllDepartment):", error);
        hasFetched.current = false;
      }
    };

    fetchData();
    
  }, []);

  return null;
}

export default AllDepartment;